import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import _ from 'lodash';
import classNames from 'classnames';

import styles from './FlowHeaderMenu.module.less';

MenuItem.propTypes = {
    menu: PropTypes.shape({
        path: PropTypes.string,
    }).isRequired,
    menuItem: PropTypes.shape({
        path: PropTypes.string,
        label: PropTypes.string,
        icon: PropTypes.node,
        hasSubMenu: PropTypes.bool,
        children: PropTypes.array,
    }).isRequired,
    params: PropTypes.object,
};

function MenuItem({menu, menuItem, params}) {
    const {path, label, icon, hasSubMenu, children} = menuItem;

    const parentPath = menu?.path ? '/' + menu?.path : '';

    function getPath(path, routeParams) {
        let routePath = `${parentPath}/${path}`;
        if (_.isEmpty(routeParams)) {
            return routePath;
        }
        Object.keys(routeParams).forEach(key => {
            routePath = routePath.replaceAll(`:${key}`, routeParams[key]);
        });
        // console.log('routePath', routePath);
        return routePath;
    }

    if (hasSubMenu && !_.isEmpty(children)) {
        return (
            <div>
                <div className={styles.subItemTitle}>
                    {icon && icon}
                    <span style={{marginLeft: 10}}>{label}</span>
                </div>
                {children.map(subItem => (
                    <Link
                        key={subItem.path}
                        to={getPath(path + '/' + subItem.path, params)}
                        className={classNames(styles.item, styles.subItem)}
                    >
                        {subItem.icon && subItem.icon}
                        <span style={{marginLeft: 10}}>{subItem.label}</span>
                    </Link>
                ))}
            </div>
        );
    }

    return (
        <Link key={path} to={getPath(path, params)} className={styles.item}>
            {icon && icon}
            <span style={{marginLeft: 10}}>{label}</span>
        </Link>
    );
}

export default MenuItem;
